import { render, staticRenderFns } from "./PredictionView.vue?vue&type=template&id=063bb2d9"
import script from "./PredictionView.vue?vue&type=script&lang=js"
export * from "./PredictionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports